import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBreadcrumbItem, IBreadcrumbsState } from "./definitions";

const initialState: IBreadcrumbsState = {
    items: [],
};

export const breadcrumbsSlice = createSlice({
    name: "breadcrumbs",
    initialState,
    reducers: {
        breadcrumbsUpdated: (state, action: PayloadAction<IBreadcrumbItem[]>) => {
            state.items = action.payload;
        },
    },
});

export const { breadcrumbsUpdated } = breadcrumbsSlice.actions;

export const breadcrumbsReducer = breadcrumbsSlice.reducer;
export default breadcrumbsSlice.reducer;
